<aside class="ui-sidebar" [class.ui-sidebar--collapsed]="collapsed()">
  <header class="ui-sidebar__brand">
    <div class="ui-sidebar__brand-main">
      <button
        type="button"
        class="brand-monogram"
        [class.brand-monogram--clickable]="collapsed()"
        [attr.aria-label]="collapsed() ? 'Expand sidebar' : 'Sidebar logo'"
        (click)="onLogoClick()"
      >
        P
      </button>
      <div class="brand-text">
        <strong>PALLADIUM</strong>
        <span>AFRICA</span>
      </div>
    </div>
    @if (!collapsed()) {
      <button type="button" class="ui-sidebar__collapse-btn" (click)="toggleCollapsed()" aria-label="Collapse sidebar">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
        </svg>
      </button>
    }
  </header>

  <nav class="ui-sidebar__nav">
    @for (item of items(); track item.path) {
      @if (item.children?.length) {
        <div class="ui-sidebar__group">
        <a
          class="ui-sidebar__item ui-sidebar__item--group-parent"
          mat-list-item
          routerLinkActive="is-active"
          [routerLink]="item.path"
          [queryParams]="item.queryParams"
          [routerLinkActiveOptions]="{ exact: true }"
          [attr.title]="collapsed() ? item.label : null"
        >
          <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="item.iconPath"></path></svg>
          <span class="ui-sidebar__label">{{ item.labelKey ? (item.labelKey | translate) : (item.label | uiLabelTranslate) }}</span>
        </a>
        <button type="button" class="ui-sidebar__group-toggle" [attr.aria-label]="'Toggle ' + item.label" (click)="toggleGroup(item.path)">
          <span class="ui-sidebar__arrow" [class.ui-sidebar__arrow--open]="isGroupExpanded(item.path)">▾</span>
        </button>
        </div>
        @if (isGroupExpanded(item.path) && !collapsed()) {
          @for (child of item.children; track child.path) {
            <a class="ui-sidebar__item ui-sidebar__item--child" mat-list-item routerLinkActive="is-active" [routerLink]="child.path" [queryParams]="child.queryParams" [routerLinkActiveOptions]="{ exact: true }">
              <span class="ui-sidebar__label">{{ child.labelKey ? (child.labelKey | translate) : (child.label | uiLabelTranslate) }}</span>
            </a>
          }
        }
      } @else {
        <a
          class="ui-sidebar__item"
          mat-list-item
          routerLinkActive="is-active"
          [routerLink]="item.path"
          [queryParams]="item.queryParams"
          [routerLinkActiveOptions]="{ exact: true }"
          [attr.title]="collapsed() ? item.label : null"
        >
          <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path [attr.d]="item.iconPath"></path>
          </svg>
          <span class="ui-sidebar__label">{{ item.labelKey ? (item.labelKey | translate) : (item.label | uiLabelTranslate) }}</span>
        </a>
      }
    }
  </nav>

  <footer class="ui-sidebar__footer">
    <div class="user-avatar">{{ user().initials }}</div>
    <div class="user-meta">
      <strong>{{ user().name }}</strong>
      <span>{{ user().role }}</span>
    </div>
  </footer>
</aside>
